import { DEFAULT_FIELDS_MATCH_EMPTY_SEARCH_QUERY_WITH_ALL } from 'modules/workflowNodeEditors/components/fieldsMatchEditor/constants';
import { NodeConfig } from 'modules/workflows/types';
import { NODE_CONFIGS } from '../../../constants/nodes/nodeConfigs';
import { NODE_TYPES } from '../../../constants/nodes/nodeConstants';
import { NODE_DATA_BY_TYPE, NODE_STRUCTURE_BY_TYPE } from '../../../constants/nodes/nodeData';

const FIELDS_MATCH_CONFIG_WITH_ALL = {
  ...NODE_CONFIGS[NODE_TYPES.FIELDS_MATCH],
  data: {
    ...NODE_STRUCTURE_BY_TYPE[NODE_TYPES.FIELDS_MATCH],
    id: NODE_TYPES.FIELDS_MATCH,
    nodeData: {
      ...NODE_DATA_BY_TYPE[NODE_TYPES.FIELDS_MATCH],
      searchQuery: DEFAULT_FIELDS_MATCH_EMPTY_SEARCH_QUERY_WITH_ALL,
    },
  },
};

export const useGetNodeConfig = (featureFlagged: boolean) => {
  return (nodeType: string): NodeConfig => {
    return featureFlagged && nodeType === NODE_TYPES.FIELDS_MATCH
      ? FIELDS_MATCH_CONFIG_WITH_ALL
      : NODE_CONFIGS[nodeType];
  };
};
